import gql from 'graphql-tag';

// V2
export const SAVE_MATERIAL_REQUEST = gql`
mutation SAVE_MATERIAL_REQUEST($requestTypeId: Int, $name: String, $itemNameCodeId: Int, $segmento: Int, $familia: Int, $clase: Int, $classGroupId: Int, $estimatedPrice: numeric, $unitId: Int, $analystNameId: Int, $annualConsumptionId: Int, $availibilityId: Int, $categoryId: Int, $erpCode: String, $colloquial1: String, $colloquial2: String, $colloquial3: String, $colloquial4: String, $colloquial5: String, $operationalAreaId1: Int, $operationalAreaId2: Int, $operationalAreaId3: Int, $operationalAreaId4: Int, $componentCodeId1: Int, $componentCodeId2: Int, $componentCodeId3: Int, $componentCodeId4: Int, $criticality: String, $criticalitySOSId: Int, $dateSOS: timestamp, $enabledManufacturer2: Boolean, $equipmentReferenceId1: Int, $equipmentReferenceId2: Int, $equipmentReferenceId3: Int, $equipmentReferenceId4: Int, $equipmentTypeId1: Int, $equipmentTypeId2: Int, $equipmentTypeId3: Int, $equipmentTypeId4: Int, $expenseItemId: Int, $extendDescription: String, $hazardIndexId: Int, $installedQuantity1: Int, $installedQuantity2: Int, $installedQuantity3: Int, $installedQuantity4: Int, $isActive: Boolean, $manufacturerAbbreviation1: String, $manufacturerAbbreviation2: String, $manufacturerId1: Int, $manufacturerId2: Int, $manufacturerPre1: bpchar, $manufacturerPre2: bpchar, $partNumber1: String, $partNumber2: String, $preEquipmentReference1: String, $preEquipmentReference2: String, $preEquipmentReference3: String, $preEquipmentReference4: String, $preference1: Int, $preference2: Int, $purchasing: Int, $qualifierStockId: String, $qualifierStockId2: String, $reemplazaCodigoEllipse: String, $referenceGroup1: Int, $referenceGroup2: Int, $referenceGroup3: Int, $referenceGroup4: Int, $reorderPoint: Int, $reorderQuantity: Int, $responsibleAreaId: Int, $shortDescription: String, $stockMaxSOS: Int, $stockMin: Int, $stockMinSOS: Int, $stockTypeId: Int, $urgency: smallint, $userResponsibleSOS: String, $warehouseId: Int, $workflowId: Int, $workflowStepId: Int, $isIntegrated: smallint = null, $lastAction: Int = null, $searchStatistics: String = null, $organizationDivisionId: Int!) {
  insert_mdm_collahuasi_material_creation(objects: {
    searchStatistics: $searchStatistics,
    erpCode: $erpCode,
    isIntegrated: $isIntegrated,
    workflowId: $workflowId,
    workflowStepId: $workflowStepId,
    requestTypeId: $requestTypeId,
    name: $name,
    itemNameCodeId: $itemNameCodeId,
    segmento: $segmento,
    familia: $familia,
    clase: $clase,
    classGroupId: $classGroupId,
    estimatedPrice: $estimatedPrice,
    unitId: $unitId,
    urgency: $urgency,
    reemplazaCodigoEllipse: $reemplazaCodigoEllipse,
    manufacturerPre1: $manufacturerPre1,
    manufacturerId1: $manufacturerId1,
    manufacturerAbbreviation1: $manufacturerAbbreviation1,
    partNumber1: $partNumber1,
    manufacturerPre2: $manufacturerPre2,
    manufacturerId2: $manufacturerId2,
    manufacturerAbbreviation2: $manufacturerAbbreviation2,
    partNumber2: $partNumber2,
    enabledManufacturer2: $enabledManufacturer2,
    categoryId: $categoryId,
    stockTypeId: $stockTypeId,
    userResponsibleSOS: $userResponsibleSOS,
    dateSOS: $dateSOS,
    stockMinSOS: $stockMinSOS,
    stockMaxSOS: $stockMaxSOS,
    criticalitySOSId: $criticalitySOSId,
    availibilityId: $availibilityId,
    annualConsumptionId: $annualConsumptionId,
    expenseItemId: $expenseItemId,
    hazardIndexId: $hazardIndexId,
    responsibleAreaId: $responsibleAreaId,
    warehouseId: $warehouseId,
    criticality: $criticality,
    qualifierStockId: $qualifierStockId,
    operationalAreaId1: $operationalAreaId1,
    equipmentTypeId1: $equipmentTypeId1,
    equipmentReferenceId1: $equipmentReferenceId1,
    referenceGroup1: $referenceGroup1,
    componentCodeId1: $componentCodeId1,
    installedQuantity1: $installedQuantity1,
    operationalAreaId2: $operationalAreaId2,
    equipmentTypeId2: $equipmentTypeId2,
    equipmentReferenceId2: $equipmentReferenceId2,
    referenceGroup2: $referenceGroup2,
    componentCodeId2: $componentCodeId2,
    installedQuantity2: $installedQuantity2,
    operationalAreaId3: $operationalAreaId3,
    equipmentTypeId3: $equipmentTypeId3,
    equipmentReferenceId3: $equipmentReferenceId3,
    referenceGroup3: $referenceGroup3,
    componentCodeId3: $componentCodeId3,
    installedQuantity3: $installedQuantity3,
    operationalAreaId4: $operationalAreaId4,
    equipmentTypeId4: $equipmentTypeId4,
    equipmentReferenceId4: $equipmentReferenceId4,
    referenceGroup4: $referenceGroup4,
    componentCodeId4: $componentCodeId4,
    installedQuantity4: $installedQuantity4,
    colloquial1: $colloquial1,
    colloquial2: $colloquial2,
    colloquial3: $colloquial3,
    colloquial4: $colloquial4,
    colloquial5: $colloquial5,
    shortDescription: $shortDescription,
    extendDescription: $extendDescription,
    stockMin: $stockMin,
    analystNameId: $analystNameId,
    isActive: $isActive,
    preEquipmentReference1: $preEquipmentReference1,
    preEquipmentReference2: $preEquipmentReference2,
    preEquipmentReference3: $preEquipmentReference3,
    preEquipmentReference4: $preEquipmentReference4,
    preference1: $preference1,
    preference2: $preference2,
    purchasing: $purchasing,
    qualifierStockId2: $qualifierStockId2,
    reorderPoint: $reorderPoint,
    reorderQuantity: $reorderQuantity,
    lastAction: $lastAction,
    organizationDivisionId: $organizationDivisionId,
  }
  ) {
    returning {
      id
    }
  }
}
`;

export const SET_SUGGESTED_PROVIDERS = gql`
mutation SET_SUGGESTED_PROVIDERS($id: Int!, $searchStatisticProvider: String) {
  update_mdm_collahuasi_material_creation_by_pk(pk_columns: {id: $id}, _set: {searchStatisticProvider: $searchStatisticProvider}) {
    searchStatisticProvider
  }
}
`;

export const UPDATE_MATERIAL_REQUEST = gql`
mutation UPDATE_MATERIAL_REQUEST($id: Int!, $updatedAt: timestamptz, $requestTypeId: Int, $name: String, $itemNameCodeId: Int, $segmento: Int, $familia: Int, $clase: Int, $classGroupId: Int, $estimatedPrice: numeric, $unitId: Int, $analystNameId: Int, $annualConsumptionId: Int, $availibilityId: Int, $categoryId: Int, $erpCode: String, $colloquial1: String, $colloquial2: String, $colloquial3: String, $colloquial4: String, $colloquial5: String, $operationalAreaId1: Int, $operationalAreaId2: Int, $operationalAreaId3: Int, $operationalAreaId4: Int, $componentCodeId1: Int, $componentCodeId2: Int, $componentCodeId3: Int, $componentCodeId4: Int, $criticality: String, $criticalitySOSId: Int, $dateSOS: timestamp, $enabledManufacturer2: Boolean, $equipmentReferenceId1: Int, $equipmentReferenceId2: Int, $equipmentReferenceId3: Int, $equipmentReferenceId4: Int, $equipmentTypeId1: Int, $equipmentTypeId2: Int, $equipmentTypeId3: Int, $equipmentTypeId4: Int, $expenseItemId: Int, $extendDescription: String, $hazardIndexId: Int, $installedQuantity1: Int, $installedQuantity2: Int, $installedQuantity3: Int, $installedQuantity4: Int, $isActive: Boolean, $manufacturerAbbreviation1: String, $manufacturerAbbreviation2: String, $manufacturerId1: Int, $manufacturerId2: Int, $manufacturerPre1: bpchar, $manufacturerPre2: bpchar, $partNumber1: String, $partNumber2: String, $preEquipmentReference1: String, $preEquipmentReference2: String, $preEquipmentReference3: String, $preEquipmentReference4: String, $preference1: Int, $preference2: Int, $purchasing: Int, $qualifierStockId: String, $qualifierStockId2: String, $reemplazaCodigoEllipse: String, $referenceGroup1: Int, $referenceGroup2: Int, $referenceGroup3: Int, $referenceGroup4: Int, $reorderPoint: Int, $reorderQuantity: Int, $responsibleAreaId: Int, $shortDescription: String, $stockMaxSOS: Int, $stockMin: Int, $stockMinSOS: Int, $stockTypeId: Int, $urgency: smallint, $userResponsibleSOS: String, $warehouseId: Int, $workflowId: Int, $workflowStepId: Int, $isIntegrated: smallint = null, $lastAction: Int = null, $partNumberRf1: String = null, $partNumberRf2: String = null, $organizationDivisionId: Int!) {
  update: update_mdm_collahuasi_material_creation_by_pk(pk_columns: {id: $id}, _set: {
    updatedAt: $updatedAt
    erpCode: $erpCode,
    isIntegrated: $isIntegrated,
    workflowId: $workflowId,
    workflowStepId: $workflowStepId,
    requestTypeId: $requestTypeId,
    name: $name,
    itemNameCodeId: $itemNameCodeId,
    segmento: $segmento,
    familia: $familia,
    clase: $clase,
    classGroupId: $classGroupId,
    estimatedPrice: $estimatedPrice,
    unitId: $unitId,
    urgency: $urgency,
    reemplazaCodigoEllipse: $reemplazaCodigoEllipse,
    manufacturerPre1: $manufacturerPre1,
    manufacturerId1: $manufacturerId1,
    manufacturerAbbreviation1: $manufacturerAbbreviation1,
    partNumber1: $partNumber1,
    manufacturerPre2: $manufacturerPre2,
    manufacturerId2: $manufacturerId2,
    manufacturerAbbreviation2: $manufacturerAbbreviation2,
    partNumber2: $partNumber2,
    enabledManufacturer2: $enabledManufacturer2,
    categoryId: $categoryId,
    stockTypeId: $stockTypeId,
    userResponsibleSOS: $userResponsibleSOS,
    dateSOS: $dateSOS,
    stockMinSOS: $stockMinSOS,
    stockMaxSOS: $stockMaxSOS,
    criticalitySOSId: $criticalitySOSId,
    availibilityId: $availibilityId,
    annualConsumptionId: $annualConsumptionId,
    expenseItemId: $expenseItemId,
    hazardIndexId: $hazardIndexId,
    responsibleAreaId: $responsibleAreaId,
    warehouseId: $warehouseId,
    criticality: $criticality,
    qualifierStockId: $qualifierStockId,
    operationalAreaId1: $operationalAreaId1,
    equipmentTypeId1: $equipmentTypeId1,
    equipmentReferenceId1: $equipmentReferenceId1,
    referenceGroup1: $referenceGroup1,
    componentCodeId1: $componentCodeId1,
    installedQuantity1: $installedQuantity1,
    operationalAreaId2: $operationalAreaId2,
    equipmentTypeId2: $equipmentTypeId2,
    equipmentReferenceId2: $equipmentReferenceId2,
    referenceGroup2: $referenceGroup2,
    componentCodeId2: $componentCodeId2,
    installedQuantity2: $installedQuantity2,
    operationalAreaId3: $operationalAreaId3,
    equipmentTypeId3: $equipmentTypeId3,
    equipmentReferenceId3: $equipmentReferenceId3,
    referenceGroup3: $referenceGroup3,
    componentCodeId3: $componentCodeId3,
    installedQuantity3: $installedQuantity3,
    operationalAreaId4: $operationalAreaId4,
    equipmentTypeId4: $equipmentTypeId4,
    equipmentReferenceId4: $equipmentReferenceId4,
    referenceGroup4: $referenceGroup4,
    componentCodeId4: $componentCodeId4,
    installedQuantity4: $installedQuantity4,
    colloquial1: $colloquial1,
    colloquial2: $colloquial2,
    colloquial3: $colloquial3,
    colloquial4: $colloquial4,
    colloquial5: $colloquial5,
    shortDescription: $shortDescription,
    extendDescription: $extendDescription,
    stockMin: $stockMin,
    analystNameId: $analystNameId,
    isActive: $isActive,
    preEquipmentReference1: $preEquipmentReference1,
    preEquipmentReference2: $preEquipmentReference2,
    preEquipmentReference3: $preEquipmentReference3,
    preEquipmentReference4: $preEquipmentReference4,
    preference1: $preference1,
    preference2: $preference2,
    purchasing: $purchasing,
    qualifierStockId2: $qualifierStockId2,
    reorderPoint: $reorderPoint,
    reorderQuantity: $reorderQuantity,
    lastAction: $lastAction
    partNumberRf1: $partNumberRf1,
    partNumberRf2: $partNumberRf2,
    organizationDivisionId: $organizationDivisionId
  }) {
    id
  }
}
`;

export const INSERT_WORKFLOW_STEP_LOG = gql`
mutation INSERT_WORKFLOW_STEP_LOG($actionId: Int!, $actualStep: Int, $beforeStep: Int, $comment: String = null, $materialCreationId: Int, $workflowId: Int!, $actionDate: timestamp = null, $endAction: timestamp = null) {
  logId: insert_mdm_workflow_step_log(objects: {actionId: $actionId, actualStep: $actualStep, beforeStep: $beforeStep, comment: $comment, materialCreationId: $materialCreationId, workflowId: $workflowId, actionDate: $actionDate, endAction: $endAction}) {
    returning {
      id
    }
  }
}
`;

export const UPDATE_WORKFLOW_STEP_LOG = gql`
mutation UPDATE_WORKFLOW_STEP_LOG($id: Int!, $comment: String = null, $endAction: timestamp) {
  update_mdm_workflow_step_log_by_pk(pk_columns: {id: $id}, _set: {endAction: $endAction, comment: $comment}) {
    id
  }
}
`;

export const SEND_EMAIL_NOTIFICATION = gql`
mutation SEND_EMAIL_NOTIFICATION($actionId: Int!, $materialCreationId: Int!, $workflowStepId: Int!, $organizationDivisionId: Int!) {
  newNotification(actionId: $actionId, materialCreationId: $materialCreationId, workflowStepId: $workflowStepId, organizationDivisionId: $organizationDivisionId) {
    msg
    error
  }
}
`;




// WEBPACK FOOTER //
// ./src/store/graphql/mutations/catalogerUser.js